import React from 'react';
import { Button } from "@mui/material";
import { buttonText } from "../utilities/constants";
import Header from "../component/Header";
import Footer from "../component/Footer";
import { useLocation, useNavigate } from "react-router-dom";

const Error = () => {
  const navigate  = useNavigate();
    const location = useLocation();
    const errorType = location.state?.errorType;

    const handleClick = () => {
      
      navigate('/public/metDentalRegistration');
    }


    const messages = {
        registration: {
          boldMessage: `
            We are sorry.
            We have trouble verifying your information.
          `,
          normalMessage: `
            Please check you entered your information correctly
            or contact Customer Support at 1-877-MET-DDS9 (1-877-638-3379) 
            8 AM - 11 PM EST
          `,
        },
        technical: {
          boldMessage: `
            We are sorry.
            The system has timed out due to a technical error.
          `,
          normalMessage: `
            Please try again later
            or contact Customer Support at 1-877-MET-DDS9 (1-877-638-3379) 
            8 AM - 11 PM EST.
          `,
        },
        };
        const { boldMessage, normalMessage } = messages[errorType] || messages.technical;
  return (
    <>
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        color: "#333333",
        alignItems: "center",
        height: "100vh",
        padding: "0.5rem",
        fontFamily: "Noto Sans",
        marginTop: "5rem",
      }}
    >
      <Header />
      <div
        style={{
          textAlign: "center",
          marginTop: '3rem',
          width: "90%", // Use a percentage for responsive width
          maxWidth: "32rem", // Limit the maximum width
          display: "flex",
          flexDirection: "column",
          overflowWrap: "break-word", // Ensures text wraps within the container
          whiteSpace: "pre-line", // Preserve whitespace and line breaks
        }}
      >
        <h6 style={{ fontWeight: "bold", marginBottom: "0.5rem" }}>
          {boldMessage}
        </h6>
        <p>{normalMessage}</p>
      </div>
      <Button
        sx={{
          backgroundColor: "white",
          border: "2px solid #007ABC",
          fontWeight: "bolder",
          padding: "4px 3rem",
          marginTop: "4rem",
          borderRadius: "2px",
          marginBottom: "11rem",
        }}
        onClick={handleClick}
      >
        {buttonText}
      </Button>
     

      
    </div>
    <Footer />
    </>
  );
};

export default Error;





